import React from 'react';
import PropTypes from 'prop-types';
import * as productConfig from '../../config/productsDictionary';
import GroupedMultiSelect from './GroupedMultiSelect';
import { useMemo } from 'react';


// Accepts the full productTree for correct child lookup
function transformProduct(product, productTree) {
  const result = {
    label: product.label,
    value: product.key,
  };
  if (product.children && Array.isArray(product.children)) {
    result.children = product.children.map(child => {
      // If child is a string, look up the product by key in the tree
      if (typeof child === 'string') {
        // Search all groups for the child key
        const found = Object.values(productTree).flat().find(p => p.key === child);
        return found ? transformProduct(found, productTree) : null;
      }
      // If child is an object, recurse (supports unlimited depth)
      return transformProduct(child, productTree);
    }).filter(Boolean);
  }
  return result;
}


function transformProductsForMultiSelect(productsByGroup) {
  // Pass the full tree to each transformProduct call
  // Find the group label from the group definition (productGroupKeys)
  // Fallback to groupLabel if not found
 
  console.log('Transforming products for multi-select. Input groups:', productsByGroup);

  return Object.entries(productsByGroup).map(([groupKey, productGroup]) => {
    return {
      value: productGroup.key,
      label: productGroup.label,
      isGroup: true,
      children: productGroup.children.map(product => transformProduct(product, productsByGroup))
    };
  });
}

const ProductDropdown = ({ selectedValues, onChange, productGroup, restrictProductGroups = null, ...props }) => {

  const products = useMemo(() => productConfig.getProducts(), []);
  const productTree = () => productConfig.getProductsTree(restrictProductGroups);
  const productGroups = () => { return transformProductsForMultiSelect(productTree());};

  // Utility to map product keys to labels
  const getProductLabel = (key) => {
    const prod = products[key];
    return prod ? prod.label : key;
  };

  // Debug: log selected labels
  console.log('Selected product labels:', selectedValues.map(getProductLabel));

  return (
    <div>
      <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}>Product: </label>

      {/* Debug: log the type and value of groups prop */}
      {(() => {
        const groupsValue = productGroups();
        console.log('ProductDropdown: groups prop type:', typeof groupsValue, Array.isArray(groupsValue) ? 'array' : 'not array', groupsValue);
        return null;
      })()}
      <GroupedMultiSelect
        groups={productGroups()}
        selectedValues={selectedValues}
        onChange={onChange}
        {...props}
      />
    </div>
  );
};


ProductDropdown.propTypes = {
  selectedValues: PropTypes.array,
  onChange: PropTypes.func,
  productGroup: PropTypes.string,
  restrictProductGroups: PropTypes.array,
};

export default ProductDropdown;
